import React, { Component } from "react";
import { Drawer, message, Select } from "antd";
import {CloseOutlined, EnvironmentOutlined} from '@ant-design/icons';
import {isEmpty, map, orderBy, cloneDeep} from "lodash";
import Script from "react-load-script";
import * as yup from 'yup'
import Loader from "../../../../Common/Component/Loader";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";
import DefineLocation from "../../../ProposalDetail/Component/Service/Proposal/DefineLocation";
import AllState from "../../../../../Assets/data/stateList.json";
import cross_icon from "../../../../../Assets/images/cross_icon.svg";
import Axios from "axios";
const { Option } = Select;


function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v !== "")));
}

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = [
  {
    value: 'weekly',
    key: 'Weekly',
  },
  {
    value: 'bi_monthly',
    key: 'Every Other Week',
  },
  {
    value: 'once',
    key: 'Just Once',
  },
  {
    value: 'twice_weekly',
    key: 'Twice Weekly',
  },
  {
    value: 'monthly',
    key: 'Monthly',
  }];

// service type mapping
const SERVICE_TYPE_MAPPING = [
  { value: 'pet_waste_stations', key: 'Pet Waste Stations' },
  { value: 'pet_waste_station_bags', key: 'Pet Waste Station Bags' },
  { value: 'pet_waste_station_service', key: 'Pet Waste Station Service' },
  { value: 'common_area_cleaning', key: 'Common Area Cleaning' },
  { value: 'trash_can_service', key: 'Trash Can Service' }
]

// mapping for days
const days = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];

class EditService extends Component {
  state = {
    uuid: '',
    location: {
      address: '',
      city: '',
      state: '',
      zip_code: ''
    },
    preferredServiceDays: [],
    securityCode: '',
    notes: '',
    is_btn_active: '',
    line_items: [],
    removed_items: [],
    editService: {},
    updateServiceLineItem: {},
    loader: false,
    errors: {},
    showLocation: false,
    mapZoom: 8,
    currentPosition: {},
    quoteDetail: {},
    is_address_manually: false,
    isFrist: true,
    tech: '',
    tech_list: {},
  }

  componentDidMount = () => {
    this.setServiceDetail(this.props.service)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setServiceDetail(nextProps?.service)

    if(!this.state.isFrist && !!nextProps?.Service?.errors?.service_address && nextProps?.Service?.errors?.service_address?.length > 0) {
      this.setState({
        errors: {
          ...this.state.errors,
          "location.address": nextProps?.Service?.errors?.service_address?.[0] || "Address Is Required"
        }
      })
    }

    if (Object.keys(nextProps?.Service?.editService).length > 0 &&
      JSON.stringify(nextProps?.Service?.editService) !== JSON.stringify(this.props?.Service?.editService)) {
      if (Object.keys(nextProps?.CommercialCustomer?.updateServiceLineItem) &&
        JSON.stringify(nextProps?.CommercialCustomer?.updateServiceLineItem) !== JSON.stringify(this.props.updateServiceLineItem)) {
        this.setState({ loader: false, editService: nextProps?.Service?.editService, updateServiceLineItem: nextProps?.CommercialCustomer?.updateServiceLineItem })
        setTimeout(() => this.props.getServiceOrder({ user__uuid: this.props.customerId }), 1000);
        this.props.closeDrawer();
        this.props.onEditSuccess && this.props.onEditSuccess();
        this.onClear();
      }
    }

    if (Object.keys(nextProps?.Service?.pauseService).length > 0 &&
    JSON.stringify(nextProps?.Service?.pauseService) !== JSON.stringify(this.props?.Service?.pauseService)) {
      this.setState({loader: false, pauseService: nextProps?.Service?.pauseService})
      this.props.viewService({ service_order__uuid: this.state.uuid, limit: 10, offset: 0 });
      this.props.closeDrawer();
      this.onClear();
    }

    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }

    this.setState({ loader: false })
  }

  // store drop pins
  onSaveMarkers = (markers) => {
    this.setState({location_markers: markers})
  }

  setServiceDetail = (service) => {
    if (service) {
      const preferredServiceDays = days?.filter(x => !service?.service_unavailable_days?.includes(x))
      const multiple_locations = service?.commercial_detail?.multiple_locations, location = service?.service_address
      let _markers = [];
      if (multiple_locations && multiple_locations !== "None") {
        let locations = multiple_locations?.split('MULTIPOINT')[1]
        locations = locations?.trim().substr(1, locations.trim().length - 2)
        let temp = locations?.split(', ')
        map(temp, (obj) => _markers.push({ lat: obj.split(' ')[0], lng: obj.split(' ')[1] }))
      } else if (!isEmpty(location) && !isEmpty(location?.geo_location)) {
        _markers = [{ lat: location?.geo_location?.latitude, lng: location?.geo_location?.longitude }]
      }

      let obj = {
        uuid: service?.uuid,
        location,
        geo_location: !isEmpty(location?.geo_location) ? `${location?.geo_location?.latitude}, ${location?.geo_location?.longitude}` : '',
        line_items: service?.commercial_detail?.line_items ? cloneDeep(orderBy(service?.commercial_detail?.line_items, 'created_at', 'asc')) : [],
        preferredServiceDays: preferredServiceDays || [],
        securityCode: service?.security_code ? service?.security_code : '',
        notes: service?.cleaning_notes || '',
        location_markers: _markers
      }
      if (multiple_locations) {
        obj['multiple_locations'] = multiple_locations;
      }

      if (!isEmpty(service?.service_address?.geo_location)) {
        Object.assign(obj, {currentPosition: {lat: service?.service_address?.geo_location?.latitude, lng: service?.service_address?.geo_location?.longitude}})
        Object.assign(obj, {quoteDetail: {address: service?.service_address}})
      }

      this.setState(obj, () => {
        const { location } = this.state;
        let address = location?.address ? `${location?.address}` : '';
        address += location?.city ? `, ${location?.city}` : '';
        address += location?.state ? `, ${location?.state}` : '';
        address += location?.zip_code ? `, ${location?.zip_code}` : '';

        if (this.refs['location']) {
          this.refs['location'].value = address;
        }
        // this.validate()
      });
    }
  }

  // set address
  setAddress = (addressObject, geo_location_old) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let geo_location = '';
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'county': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });

        obj = Object.assign(obj, { 'address': `${obj?.street_number || ''} ${obj?.route || ''}`.trim() })

        if (!isEmpty(components.geometry.location) && !geo_location_old) {
          Object.assign(obj, {geo_location: {latitude: components?.geometry?.location?.lat, longitude: components?.geometry?.location?.lng}})
          geo_location = !isEmpty(components?.geometry?.location) ? `${components?.geometry?.location?.lat}, ${components?.geometry?.location?.lng}` : ''
        }

        
        function isInvalid(str) {
          return !str || str.trim().length === 0;
        }

        if(isInvalid(obj?.address) || isInvalid(obj?.city) || isInvalid(obj?.state) || isInvalid(obj?.zip_code)) {
          this.setState({
            is_address_manually: true,
          })
        }

        this.setState({
          location: obj, 
          // geo_location: (geo_location_old ? geo_location_old : geo_location)
        }, () => {
          // if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          //   message.error('Please enter valid location');
          // }
          // this.validate()
        });
        return {location: obj, geo_location}
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // return;

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  // on start place change
  handlePlaceSelect = () => {
    const { autocomplete } = this.state;
    const addressObject = autocomplete?.getPlace();
    this.makeGoogleApiCall({address: addressObject?.formatted_address});
  }

  // on text change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({[e.target.name]: value});
  };

  makeGoogleApiCall = ({geo_location, address}) => {
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: removeEmpty({
        latlng: geo_location,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const result = res?.data;
      this.setAddress(result, geo_location);
    }).catch((err) => {
      console.log(err)
    })
  }

  // on geo location changed
  onGeolocationChanged = (e) => {
    const geo_location = e.target.value;
    this.setState({geo_location, is_address_manually: true})
    // if(!!geo_location) {
    //   this.makeGoogleApiCall({geo_location})
    // }
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on preferred Days Change
  onPreferredDaysChanged = (value) => {
    const isAnyInclude = value[value.length - 1] === "any";
    let newValue = [];
    if (isAnyInclude) {
      newValue = ["any"];
    } else {
      const idx = value.indexOf("any");
      if (idx > -1) value.splice(idx, 1);
      newValue = value;
    }
    this.setState({preferredServiceDays: newValue})
  };

  // on line items changed
  onLineItemsChanged = (e, index, type) => {
    const { line_items } = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    const total = parseFloat(line_items[index].rate) * parseFloat(line_items[index].quantity)
    Object.assign(line_items[index], {[e.target.name]: value, total})
    this.setState({line_items})
  }

  // on line items remove
  onLineItemsRemove = (index) => {
    const { line_items, removed_items } = this.state;
    if (line_items[index]?.uuid) removed_items.push(line_items[index]?.uuid)
    line_items.splice(index, 1)
    this.setState({line_items, removed_items})
  }

  // To toggle location modal
  toggleLocation = () => {
    this.setState((prevState) => ({ showLocation: !prevState.showLocation }))
  }

  // validate required fields
  validate = () => {
    const {
      tech,
      location,
      preferredServiceDays,
      line_items,
      rawAddress,
      geo_location
    } = this.state;

    function isAddressNotEmpty() {
      // console.log(location)
      if(
          location?.address?.length > 0
          || location?.city?.length > 0
          || location?.state?.length > 0
          || location?.zip_code?.length > 0
      ) {
        return true;
      }
      return false;
    }

    // const { service } = this.props;
    const schema = yup.object().shape({
      ...((!geo_location || isAddressNotEmpty()) && {
        location: yup.object().shape({
          address: yup.string().required('Address is required.'),
          city: yup.string().required('city is required.'),
          // state with string validation length > 0
          state: yup.string().required('State is required.').min(2, 'State is required.'),
          zip_code: yup.string().required('zip code is required.'),
        })
      }),
      // preferredServiceDays: yup.array(yup.string()).required("Preferred service days is required"),
      line_items: yup.array(yup.object().shape({
        // frequency: yup.string().required('Frequency is required.'),
        item: yup.string().required('Product/Service is required.'),
        // quantity: yup.number().min(1).required('Quantity is required.'),
        // rate: yup.number().min(1).required('Rate is required.'),
      }))
    });

    const data = {
      location,
      preferredServiceDays,
      line_items
    };

    // if(!geo_location && !rawAddress) {
    //   this.setState({errors: {"location.address": "Address or Geo-Location is required"}});
    //   return
    // }

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({is_btn_active: true, errors: {}});
        // axios.post(`${config.getHost()}service-order/validate_address/`, {
        //   field_office_uuid: service?.field_office_uuid,
        //   address: location?.formatted_address
        // }).then((response) => {
        //   if (Object.keys(response).length > 0 && response?.data?.is_valid) {
        this.onAddService(); 
      }      
        // }).catch((error) => {
        //   message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.');
        // });
        // }
      ).catch((error) => {
        console.log(error);
        let err_data = {};

        map(error.inner, (item) => {err_data[item.path] = item.message});
        this.setState({errors: err_data, is_btn_active: false});
      });
    }, 200);
  };

  // on clear
  onClear = () => {
    this.setState({
      location: {
        address: '',
        city: '',
        state: '',
        zip_code: ''
      },
      geo_location: '',
      preferredServiceDays: [],
      securityCode: '',
      notes: '',
      errors: {},
      line_items: []
    });
  }

  // on Add Service
  onAddService = () => {
    const {
      tech,
      uuid,
      regularity,
      preferredServiceDays,
      notes,
      location,
      line_items,
      securityCode,
      location_markers,
      geo_location,
      rawAddress
    } = this.state;
    this.setState({ loader: true });
    let arr = [], location_str = '';
    const service_unavailable_days = days?.filter(x => !preferredServiceDays?.includes(x));

    if (!location?.geo_location) {
      delete location?.geo_location
    }

    map(location_markers, (obj, index) => location_str += `${obj.lat} ${obj.lng} ${location_markers?.length - 1 !== index ? ', ' : ''}`)

    // Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
    //   params: {
    //     ...(!!geo_location ? { latlng: geo_location } : { address: encodeURI(rawAddress) }),
    //     key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
    //   }
    // }).then((res) => {

    //   const formatted = this.setAddress(res?.data) || {}

    let obj = {
      preferred_technician_uuid: tech,
      service_address: ({...this.state?.location,...(geo_location?.trim() === '' ? {geo_location: null} : {geo_location})}),
      // service_address: (location?.street_number && location?.route) ? { ...location, address: `${location?.street_number} ${location?.route}` } : location,
      frequency: regularity,
      cleaning_notes: notes,
      service_unavailable_days,
      security_code: securityCode,
      //multiple_locations: location_str ? `SRID=4326;MULTIPOINT (${location_str})` : null,
    }
    if (location_str) {
      obj['multiple_locations'] = location_str ? `SRID=4326;MULTIPOINT (${location_str})` : null;
    }
  
    if (geo_location) {
      Object.assign(obj.service_address, {geo_location: {latitude: geo_location?.split(',')?.[0]?.trim(), longitude: geo_location?.split(',')?.[1]?.trim() }})
    }
  
    arr.push(this.props.editService(uuid, obj))
    map(line_items, (obj) => arr.push(this.props.updateServiceLineItem(obj.uuid, {...obj, rate: obj.rate || "0", quantity: obj.quantity || "0"})))
      
    // })
  };

  renderLineItems = (obj, index) => {
    // if (obj.frequency === 'once') return
    const {errors} = this.state;
    return (
      <div key={`line_items${index}`} style={{ border: "1px solid #EBEBEB", padding: "10px", borderRadius: "4px", marginBottom: "10px" }}>
        <div className="card-title flex">
          <h5>Subscription {index + 1}</h5>
          {/*<Popconfirm*/}
          {/*  title="Are you sure?"*/}
          {/*  onConfirm={() => this.onLineItemsRemove(index)}*/}
          {/*  okText="Yes"*/}
          {/*  cancelText="No"*/}
          {/*>*/}
          {/*  <CloseCircleOutlined/>*/}
          {/*</Popconfirm>*/}
        </div>
        <div className="fitem half-fitem">
          <div className="fitem half-fitem">
            <label>Regularity</label>
            {(obj?.item !== 'pet_waste_stations' && obj?.model !== 'mounted') ?
              <Select
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                placeholder={'Select Regularity'}
                value={obj.frequency ? obj?.frequency : undefined}
                onChange={(e) => this.onLineItemsChanged({ target: { name: 'frequency', value: e } }, index)}
              >
                {
                  FREQUENCY_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
                }
              </Select> : <div className={"fitem tbl-cell model mt-10"}><h6>{'N/A'}</h6></div>
            }
          </div>
          <div className="fitem half-fitem">
            <label>Product/Service</label>

            <Select
              showArrow
              virtual={false}
              style={{ width: '100%' }}
              value={obj.item ? obj?.item : undefined}
              placeholder={'Select Product/Service'}
              onChange={(e) => {
                this.onLineItemsChanged({ target: { name: 'item', value: e } }, index)
                if (e !== 'pet_waste_stations' && obj?.model === 'mounted') {
                  this.onLineItemsChanged({ target: { name: 'model', value: '' } }, index)
                } else if (e === 'pet_waste_stations' && obj?.model !== 'mounted') {
                  this.onLineItemsChanged({ target: { name: 'frequency', value: '' } }, index)
                }
              }}
            >
              {
                SERVICE_TYPE_MAPPING?.map(obj => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)
              }
            </Select>
            {errors?.[`line_items.${index}.item`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`line_items.${index}.item`]}</label> : ''}
          </div>
        </div>
        <div className="fitem half-fitem">
          <div className="fitem half-fitem">
            <label htmlFor={"quantity"}>Qty</label>
            <input
              type="text"
              className={'form-control mb-10'}
              placeholder={'Quantity'}
              name="quantity"
              id="quantity"
              value={obj.quantity}
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onLineItemsChanged(e, index)}
            />
          </div>
          <div className="fitem half-fitem">
            <label htmlFor={"quantity"}>Rate($)</label>
            <input
              type="text"
              className={'form-control mb-10'}
              placeholder={'Rate'}
              name="rate"
              id="rate"
              value={obj?.rate}
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onLineItemsChanged(e, index)}
            />
          </div>
        </div>
      </div>
    )

  }

  // render all state
  renderAllState = () => {
    return map([
      {
        "Name": "None",
        "abbreviation": "",
      }
      , ...AllState.AllState], (item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  onAddressChange = (e) => {
    const {location} = this.state;
    Object.assign(location, {[e.target.name]: e.target.value})
    this.setState({location, errors: {}});
  };
  
  render() {
    const { closeDrawer, visible } = this.props;
    const {
      tech,
      tech_list,
      preferredServiceDays,
      securityCode,
      notes,
      location,
      line_items,
      loader,
      errors,
      location_markers,
      showLocation,
      mapZoom, quoteDetail,
      currentPosition,
      geo_location,
      is_address_manually
    } = this.state;

    let address = location?.address ? `${location?.address}` : '';
    address += location?.city ? `, ${location?.city}` : '';
    address += location?.state ? `, ${location?.state}` : '';
    address += location?.zip_code ? `, ${location?.zip_code}` : '';

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={visible}
        key={'right'}
        width={'525'}
        className="drawer-wrapper"
      >
        <div className="edit-service-drawer  rdrawer">
          {loader && <Loader />}
          <div className="card-head flex ai-center">
            <h4>Edit Service</h4>
            <CloseOutlined onClick={() => {
              this.onClear();
              closeDrawer()
            }} />
          </div>
          <div className="card-row flex flex-column">
            <div className="card-full" onClick={() => this.toggleLocation()}>
              {!isEmpty(location_markers) ? !showLocation ? <CustomMap markers={location_markers} /> : '' :
                <div style={{'justifyContent': 'center', 'alignItems': 'center', 'display': 'flex', 'flexDirection': 'column'}}>
                  <EnvironmentOutlined />
                  <h3>Locations</h3>
                  <p>Click to add locations.</p>
                </div>
              }
            </div>
            <div className="card-full">
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="address">Service Address</label>
                  <div className="google_search_place">
                    <Script
                      url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                      onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                    />

                    <input
                      autoComplete="off"
                      type="text"
                      ref="address"
                      placeholder={"Address"}
                      name="google_address"
                      id="google_address"
                      onChange={(e) => {
                        if (!e.target.value) {
                          this.setState({
                            location: { address: '', state: '', city: '', zip_code: '' }
                          })
                        }
                      }}
                      disabled={is_address_manually}
                    />
                    <b>or <a href="/" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: true,
                      })
                    }}><u>enter address manually</u></a></b>
                  </div>
                  {
                    is_address_manually &&
                      <div className="manually_address">
                        <a href="/#" onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            is_address_manually: false,
                            // location: { address: '', state: '', city: '', zip_code: '' },
                          })
                        }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                        <br />

                        <div className="form-group mb-20">
                          <div className="fitem">
                            <input
                              type="text"
                              placeholder="Address"
                              name="address"
                              value={location?.address}
                              onChange={(e) => this.onAddressChange(e)}
                            />
                          </div>
                          <div className="half-fitem fitem">
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                placeholder="City"
                                name="city"
                                value={location?.city}
                                onChange={(e) => this.onAddressChange(e)}
                              />
                            </div>
                            <div className="half-fitem fitem">
                              <Select
                                showArrow={true}
                                name="state"
                                placeholder="State"
                                onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                                value={location?.state || undefined}
                                virtual={false}
                              >
                                {this.renderAllState()}
                              </Select>
                            </div>
                            <div className="half-fitem fitem">
                              <input
                                type="text"
                                className='form--control'
                                placeholder="ZIP Code"
                                name="zip_code"
                                maxLength={5}
                                minLength={5}
                                onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                                value={location?.zip_code || ''}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                  {((errors?.['location.address'] || errors?.['location.city'] || errors?.['location.state'] || errors?.['location.zip_code']) && !loader) ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['location.address'] || errors?.['location.city'] || errors?.['location.state'] || errors?.['location.zip_code'] || 'Address is required'}</label> : ''}
                </div>
                <div className="fitem">
                  <input
                    type="text"
                    ref="startLocation"
                    placeholder={'Latitude, Longitude'}
                    name="geo_location"
                    id="geo_location"
                    value={geo_location}
                    onChange={(e) => this.onGeolocationChanged(e)}
                  />
                </div>
                {/* for subscription */}
                {map(line_items, this.renderLineItems)}
                {/*-------*/}
                <div className="fitem">
                  <label style={{ textTransform: "None" }}>Preferred Service Day(s)</label>
                  <Select
                    mode="multiple"
                    showArrow
                    virtual={false}
                    style={{ width: '100%', height: "auto" }}
                    value={preferredServiceDays}
                    name={"preferredServiceDays"}
                    onChange={(e) => this.onPreferredDaysChanged(e)}
                  >
                    <Option value={'any'}>{'Any'}</Option>
                    <Option value={'sun'}>{'Sunday'}</Option>
                    <Option value={'mon'}>{'Monday'}</Option>
                    <Option value={'tues'}>{'Tuesday'}</Option>
                    <Option value={'wed'}>{'Wednesday'}</Option>
                    <Option value={'thurs'}>{'Thursday'}</Option>
                    <Option value={'fri'}>{'Friday'}</Option>
                    <Option value={'sat'}>{'Saturday'}</Option>
                  </Select>
                </div>
              </div>
              <div className="form-group">
                <label className="black">Do we need a security code to access this building?</label>
                <div className="fitem">
                  <label htmlFor={"securityCode"}>Security Code</label>
                  <input
                    type="text"
                    className={'form-control mb-10'}
                    placeholder={'Security code for the door'}
                    name="securityCode"
                    id="securityCode"
                    value={securityCode}
                    onChange={(e) => this.onTextChange(e)}
                  />
                </div>
                <div className="fitem">
                  <label htmlFor={"notes"}>Notes</label>
                  <input
                    type="text"
                    className={'form-control mb-10'}
                    placeholder={'Enter any additional service notes here'}
                    name="notes"
                    id="notes"
                    value={notes}
                    onChange={(e) => this.onTextChange(e)}
                  />
                </div>
                {/*<div className="text-center">*/}
                {/*  <button className="btn plain-btn danger" onClick={() => {*/}
                {/*    this.setState({loader: true})*/}
                {/*    setTimeout(() => this.props.pauseService({*/}
                {/*      service_order_uuid: uuid,*/}
                {/*      understand_pause_func: false,*/}
                {/*      pause_from: moment().format('YYYY-MM-DD'),*/}
                {/*      pause_to: null,*/}
                {/*      suspend_until_manual: true*/}
                {/*    }), 1000)*/}
                {/*  }}>Suspend this service</button>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
          <div className="footer">
            <button
              type="button"
              className="btn btn-brand btn-bdr"
              onClick={() => { this.onClear(); closeDrawer() }}
            >Cancel</button>
            <button
              // type="submit"
              className={`btn btn-primary`}
              // disabled={!is_btn_active}
              onClick={() => this.validate()}>
              Update Service
            </button>
          </div>
        </div>
        {showLocation && <DefineLocation
          zoom={mapZoom}
          visible={showLocation}
          quoteDetail={quoteDetail}
          onCancel={() => this.toggleLocation()}
          onSave={(markers, mapZoom) => {
            this.onSaveMarkers(markers);
            this.setState({mapZoom})
          }}
          markerList={!isEmpty(location_markers) ? location_markers : !isEmpty(currentPosition) ? [currentPosition] : []}/>}
      </Drawer>

    )
  }
}

export default EditService;
